import React, { useEffect, useState } from 'react'
import './course.css'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Slider from 'react-slick';
import { NavLink } from 'react-router-dom';
import accept from '../../../images/workshop_images/accept.png'
import health_seekers from '../../../images/workshop_images/health_seekers.png'
import working from '../../../images/workshop_images/working.png'
import homemakers from '../../../images/workshop_images/homemakers.png'
import student from '../../../images/workshop_images/student.png'
import professionals from '../../../images/course_images/professionals.png'
import job from '../../../images/course_images/job.png'


function Course() {
    useEffect(() => {
        // Initialize AOS
        AOS.init({ duration: 1500, easing: 'ease-in-out' });
    }, []);

    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };



    const accordionData = [
        {
            title: "Where will I find the study material?",
            content:
                "Study materials will be provided by us once you enroll. The materials are a combination of both hard and soft copies, and they will be given to you annually.",
        },
        {
            title: "Will there be classes for all the 3 years?",
            content:
                "Yes, the classes will be held for 3 months each year during the weekends, and the mode of learning will be online.",
        },
        {
            title: " Will I receive certification upon completion?",
            content:
                "Yes, you will receive a certification authorized by The Gandhi National Academy of Naturopathy upon successful completion of the course.",
        },
        {
            title: "How will the course be assessed?",
            content:
                "Students will be assessed through a combination of exams, assignments, and practical training sessions.",
        },
        {
            title: "When does the next batch start?",
            content:
                "Please contact us to know the next batch start date.",
        },
        {
            title: "What are the fees for the course?",
            content:
                "Please Contact us to know the fee structure.",
        },
        {
            title: " What is the last date for registration?",
            content:
                "Please contact us to know the last date for registration.",
        },
        {
            title: "How can I contact for more information?",
            content:
                "For further details, please contact us at theanuyoginstitute@gmail.com or call +917892307418.",
        },
        {
            title: "Is there an age limit for applicants?",
            content:
                "There is no age restriction for this course; it is open to candidates of all ages.",
        },
        {
            title: "What are the documents Required for Admission?",
            content: [
                "Aadhar Card",
                "Passport Size Photograph",
                "12th Class Marksheet",
            ],
            type: "list",
        }
    ];

    const testimonialsData = [
        {
            imgSrc: '/images/gunjan-jain.jpg',
            message: 'I am Gunjan Jain, a proud student of the NDDY course, which I came to know about through Pandit Sumat Prakash Ji. I have always had a deep desire to live closer to nature, and joining this course has been a transformative journey for me.',
            message2: 'Through the course, I learned several natural techniques like hydrotherapy, Jal Neti, Kunjal Kriya, and Laghu Shank Prakshalan, which I have seamlessly incorporated into my daily routine. These practices have significantly improved my health, providing relief from issues like acidity, cold, and stomach aches.',
            message3: 'I strongly believe that everyone should adopt these natural practices in their lifestyle. After all, a healthy body is the foundation of a healthy mind, as the saying goes, ‘Pehla Sukh Nirogi Kaya.’ This course has truly helped me align with nature and prioritize my well-being.',
            name: 'Gunjan Jain, Homemaker, Jodhpur',
        },
        {
            imgSrc: '/images/srashti-jain.png',
            message: 'The NDDY course has completely transformed my lifestyle. Its teachings have helped me stay energized, complete tasks on time, and overcome the laziness that is common among today’s youth.',
            message2: "If we connect with nature and adopt natural healing methods in our lives, we will not only remain completely healthy but also inspire others. Through Naturopathy, we learn what to eat and what to avoid. The most important takeaway is that the things provided by nature are the ones truly suitable for us. The harmful effects of artificial substances are evident in today's world.",
            message3: 'Moreover, it has deepened my connection to spirituality, and I believe everyone should adopt this lifestyle for a healthier, more balanced life.',
            name: 'Srashti Jain, Student, Jabera'
        },
        {
            imgSrc: '/images/deepak-jain.png',
            message: 'I had been suffering from a persistent cough for almost four years. I tried allopathic, homeopathic, and Ayurvedic treatments, but the relief was only temporary, and the problem kept recurring.',
            message2: 'On February 16, 2022, when my cough returned, I consulted all the local doctors, but when they couldn’t provide a solution, they advised me to seek help from a specialist. I then reached out to Guruji Pt. Vikas Ji Chhabra in Indore. He suggested I try naturopathy under the guidance of Pt. Sumat Prakash Ji. Due to certain constraints, I couldn’t visit him in person but managed to speak to him over the phone. Pt. Sumat Prakash Ji advised me to consult Dr. Suresh Jain Bhind (Tauji).',
            message3: 'Tauji advised me to give up grains and pulses for 10 days and follow hydrotherapy and other naturopathy methods along with it. I did it disciplinedly and gradually increased it to 30 days. After this procedure, I got a lot of relief from my cough, which completely strengthened my faith in Naturopathy.Following this, I enrolled in the NDDY course. While studying this course, I have not only applied these practices to my own life but also encouraged others to adopt naturopathy. It has played a transformative role in improving my life.',
            name: 'Deepak Jain, Founder, Digamber Namkeen, Pipariya'
        },
        {
            imgSrc: '/images/divya-jain.jpg',
            message: "I am currently pursuing CA alongside Naturopathy. Being the granddaughter of an Ayurvedic doctor, my family and I have never relied on allopathic medicine. A few years ago, I learned about Naturopathy from my Guru, Pandit Sumit Prakash Ji, and my sisters and I decided to pursue it. The transformation it has brought to my life and my family's is remarkable.'",
            message2: 'Naturopathy is not just about curing diseases; it’s a way of living. We transitioned from Ayurveda to Naturopathy, started using earthen pots, and adopted more scientific ways of cooking. However, the changes extend far beyond cooking and diet. My perspective on life has evolved—I now embrace challenges and approach my studies with greater focus and clarity. In today’s health-conscious era dominated by technology and social media, it’s crucial not to be swayed by every reel or video we come across. We must become our own doctors, understand the unique needs of our gut health, and avoid applying generalized solutions.',
            message3: 'Despite being a CA student, I firmly believe that pursuing Naturopathy is one of the best decisions I have ever made. Since embracing this lifestyle, there’s been a noticeable increase in happiness and positivity in our home. With the right knowledge at the right time, I am confident that I will never have to step into a hospital in my lifetime.',
            name: 'Divyata Jain, Chhindwara, MP'
        },
        {
            imgSrc: '/images/sheetal.jpeg',
            message: "I would like to express my heartfelt gratitude to my esteemed teachers—Dr. Tauji, Dr. Raghavendra Sir, and Dr. Charu Ma'am.  I remain deeply indebted to them for their guidance. It has transformed my life, improving my body, mind, and soul. Through their teachings, I have learned to harness the natural healing powers of my body and embrace a path of healing without reliance on allopathic treatments.",
            message2: 'Being a part of NDDY has been an honour. This journey has deepened my  commitment to promoting natural health and wellness within my family and the community. I highly recommend this to anyone seeking a disease-free life.',
            name: 'Sheetal Begani, Homemaker, Kolkata'
        },

    ];

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true,
    };

    return (
        <>
            <section className='consultancy-section'>
                <div className="consultancy">
                    <img src='/images/course_banner.jpg' alt="" />
                    {/* <h1 className='consultancy-heading '>EMPOWERED DECISIONS COME FROM <br /> THE RIGHT KNOWLEDGE</h1> */}
                </div>
            </section>



            <div className="course-text work-text">


                {/* <h3
                    className='fonts text-center text-dark mb-4 fw-bold'
                    style={{ maxWidth: '730px', margin: '0 auto' }}
                >
                    <strong style={{ color: '#9D3B24' }}> Our goal</strong> is to empower you to take charge of
                    <strong style={{ color: '#9D3B24' }}> your health, prevent illnesses, and inspire others</strong> to lead
                    <strong style={{ color: '#9D3B24' }}> balanced and sustainable lives.</strong>
                </h3> */}

                <h2 className='fw-bold text-dark offering-title'>DIPLOMA IN NATUROPATHY AND YOGA (NDDY)</h2>

                <h3 className='mt-4' style={{ maxWidth: '1030px', margin: '0 auto' }}><strong style={{ color: '#9D3B24' }}>The NDDY course teaches you to address your body’s essential health needs. Empower yourself to overcome health obstacles and maintain well-being, ensuring you're always ready to thrive.
                </strong></h3>

            </div>


            <section className='offering-section  choose-course mt-5'>
                <div className="container">
                    <div className="offerings">
                        <h1 className='custom offering-title' >
                            Why Choose This Course?
                        </h1>
                        <div className="course-offers all_offers" data-aos="zoom-in" data-aos-duration="1000">
                            <div className="offers">

                                <div className="offering-icon">
                                    <img src='/images/certified.png' alt="" />
                                </div>
                                <div className="offering-text">
                                    <h4 className='fw-bold'> Certified Doctor </h4>
                                    <p > Become a certified Naturopathy Doctor.</p>
                                </div>

                            </div>
                            <div className="offers">

                                <div className="offering-icon">
                                    <img src='/images/knowledge.png' alt="" />
                                </div>
                                <div className="offering-text">
                                    <h4 className='fw-bold'> Knowledge  </h4>
                                    <p >Gain in-depth knowledge of natural healing, yoga, and holistic wellness.
                                    </p>
                                </div>
                            </div>
                            <div className="offers">

                                <div className="offering-icon">
                                    <img src='/images/holistic-health.png' alt="" />
                                </div>
                                <div className="offering-text">
                                    <h4 className='fw-bold'> Holistic health</h4>
                                    <p>Learn to prevent diseases and promote holistic health. </p>
                                </div>

                            </div>
                            <div className="offers">

                                <div className="offering-icon">
                                    <img src='/images/income.png' alt="" />
                                </div>
                                <div className="offering-text">
                                    <h4 className='fw-bold'>Income Opportunity</h4>
                                    <p>Start your own wellness practice or Join the Anuyogs Consultancy program</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='yes-section' id='workshop_details'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="course-yes yes">
                                <div className="yes-header justify-content-center">
                                    <h1>WHO IS THIS COURSE FOR</h1> <img src={accept} alt="" />
                                </div>
                                <h5 className=' fw-bold text-center offering-title'>If you're passionate about Natural Living and Healing and ready to build a purposeful, meaningful career, this course is for YOU!
                                </h5>
                                <div className="course_info_who all-information">
                                    <div className="details">
                                        <div className="details-image">
                                            <img src={health_seekers} alt="" />
                                        </div>
                                        <div className="details-text">
                                            <h4 className='fw-bold'>Health Lovers</h4>
                                            <h5 className='fw-bold'>Transform your passion into a rewarding career. </h5>
                                        </div>
                                    </div>
                                    <div className="details">
                                        <div className="details-image">
                                            <img src={homemakers} alt="" />
                                        </div>
                                        <div className="details-text">
                                            <h4 className='fw-bold'>Housewives</h4>
                                            <h5 className='fw-bold'> Build a wellness career from the comfort of your home.</h5>
                                        </div>
                                    </div>
                                    <div className="details">
                                        <div className="details-image">
                                            <img src={working} alt="" />
                                        </div>
                                        <div className="details-text">
                                            <h4 className='fw-bold'>Career Changers</h4>
                                            <h5 className='fw-bold'> Transition into holistic health and wellness effortlessly.</h5>
                                        </div>
                                    </div>
                                    <div className="details">
                                        <div className="details-image">
                                            <img src={student} alt="" />
                                        </div>
                                        <div className="details-text">
                                            <h4 className='fw-bold'>Career Breakers</h4>
                                            <h5 className='fw-bold'> Restart your career with purpose—age is not a barrier!
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="details">
                                        <div className="details-image">
                                            <img src={professionals} alt="" />
                                        </div>
                                        <div className="details-text">
                                            <h4 className='fw-bold'>Ambitious Professionals</h4>
                                            <h5 className='fw-bold'> Grow in the competitive wellness industry.
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="details">
                                        <div className="details-image">
                                            <img src={job} alt="" />
                                        </div>
                                        <div className="details-text">
                                            <h4 className='fw-bold'>Job Seekers</h4>
                                            <h5 className='fw-bold'> Build a meaningful, impactful career.
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='info-section'>
                <div className="details">
                    <h2 className='text-center fw-bold mb-4'>Details Of The Course</h2>
                    <div className="all-details">


                        <div className="block" data-aos="fade-right" data-aos-duration="2000">
                            <h5><strong>Authorized By:</strong> The Gandhi National Academy of Naturopathy, New Delhi</h5>
                        </div>
                        <div className="block" data-aos="fade-right" data-aos-duration="2000">
                            <h5><strong>Facilitated By:</strong> Shri Vardhman Nyas, Amayan, Bhind
                            </h5>

                        </div>
                        <div className="block" data-aos="fade-right" data-aos-duration="2000">
                            <h5><strong>Eligibility:</strong> Senior Secondary/ 12th Class/ High School Graduate</h5>
                        </div>
                        <div className="block" data-aos="fade-left" data-aos-duration="2000">
                            <h5><strong>Duration:</strong> 3.5 years (3 Years Classes + 0.5 Years Practical Training)</h5>
                        </div>
                        <div className="block" data-aos="fade-left" data-aos-duration="2000">
                            <h5><strong>Mode:</strong> Offline and Online learning</h5>
                        </div>
                        <div className="block" data-aos="fade-left" data-aos-duration="2000">
                            <h5><strong>Language:</strong> Hindi and English</h5>
                        </div>
                    </div>
                </div>
            </section>

            <section className='learn-section'>
                <div className="container">
                    <h1>What You Will Learn</h1>

                    <div className="all-learn">
                        <h2 className='fw-bold offering-title mb-5'>Year 1: Foundations of Naturopathy </h2>
                        <div className="learn-detail" data-aos="fade-up">
                            <h4>Principles of Nature Cure</h4>
                            <h4>Anatomy & Physiology</h4>
                            <h4>Environment & Ecology</h4>
                        </div>
                    </div>
                    <div className="all-learn">
                        <h2 className='fw-bold offering-title mb-5'>Year 2: Therapeutic Techniques</h2>
                        <div className="learn-detail" data-aos="fade-up">
                            <h4>Nutrition & Fasting</h4>
                            <h4>Hydrotherapy, Chromotherapy, and Massage Therapy</h4>
                            <h4>Natural Dietetics</h4>
                        </div>
                    </div>
                    <div className="all-learn">
                        <h2 className='fw-bold offering-title mb-5'>Year 3: Advanced Healing & Wellness</h2>
                        <div className="learn-detail" data-aos="fade-up">
                            <h4>Chronic Disease Management</h4>
                            <h4>Public Health and Hygiene</h4>
                            <h4>Yoga Therapy and Shatkarma</h4>
                        </div>
                    </div>
                    <div className="mt-5">
                        <NavLink
                            to="/contact"
                            onClick={() => {
                                window.scrollTo(0, 0);
                            }}
                        >
                            <button type="button" className="btn">Contact Us Now for inquiries</button>
                        </NavLink>
                        <a href="/syllabus.pdf" download>
                            <button type="button" className="btn ms-3">Download Detailed Syllabus</button>
                        </a>
                    </div>

                </div>
            </section>


            <section className='questions-section'>
                <div className="container">
                    <h1 className='mb-5 offering-title'>Frequently Asked Questions</h1>
                    <div className="accordion">
                        {accordionData.map((item, index) => (
                            <div className="accordion-item" key={index}>
                                <button
                                    className="accordion-button"
                                    aria-expanded={activeIndex === index ? 'true' : 'false'}
                                    onClick={() => toggleAccordion(index)}
                                >
                                    <span className="accordion-title">{item.title}</span>
                                    <span className="icon" aria-hidden="true"></span>
                                </button>
                                {activeIndex === index && (
                                    <div className="accordion-content">
                                        {item.type === "list" ? (
                                            <ul>
                                                {item.content.map((listItem, i) => (
                                                    <li key={i}>{listItem}</li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p>{item.content}</p>
                                        )}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className='detail-section'>
                <div className="container">
                    <h1 className='mb-5 offering-title'> Become an expert in Natural Living & Healing, & Transform Lives!
                    </h1>
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <h1 style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)' }} className='text-dark'>DIPLOMA IN NATUROPATHY AND YOGA (NDDY)</h1>
                            <div className="course-logo-image">
                                <img src="/images/course-logo.png" alt="" />
                            </div>

                        </div>
                        <div className="col-md-6">
                            <iframe width="660" height="400" src="https://www.youtube.com/embed/y19rX131ljs?si=JkxsmBzt79IllLZc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </section>

            <section className="testimonials">
                <div className="container">
                    <h1 className='fw-bold '> <strong style={{ color: '#9D3B24' }}> Personal Journeys</strong> </h1>
                    <h4 className='mb-4 fw-bold text-center offering-title'>Discover how the NDDY course transforms lives through growth and healing.</h4>
                    <Slider {...settings}>
                        {testimonialsData.map((testimonial, index) => (
                            <div key={index} className="item">
                                <div className="shadow-effect">
                                    <img className="img-circle" src={testimonial.imgSrc} alt={testimonial.name} />
                                    <p>{testimonial.message}</p>
                                    <p>{testimonial.message2}</p>
                                    <p>{testimonial.message3}</p>
                                </div>
                                <div className="testimonial-name">{testimonial.name}</div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </section>




        </>
    )
}

export default Course
